import React from 'react';
import { ScrollView } from 'react-native';

import { VFScreen } from '@vfgroup-oneplatform/foundation/Components';
import PropTypes from 'prop-types';

import ButtonsSection from './components/ButtonsSection/ButtonsSection';
import ChooseDurationSection from './components/ChooseDurationSection/ChooseDurationSection';
import PaymentOptionsSection from './components/PaymentOptionsSection/PaymentOptionsSection';
import Section from './components/Section/Section';
import SubHeaderTitle from './components/SubHeaderTitle/SubHeaderTitle';
import style from './CreateInstalmentMainScreenStyle';

class CreateInstalmentMainScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPrimaryButtonDisabled: true,
    };
    this.selectedOptionData = {};
  }

  onSelectOption = ({ index, data }) => {
    this.selectedOptionData = data;
    this.setState({ isPrimaryButtonDisabled: false });
  };
  getVFScreenProps = () => {
    const { onClose, onBack } = this.props;

    return {
      title: 'billing_setup_installment_plan_screen_title',
      onClose: onClose,
      closeButtonTestID: 'createInstallmentCloseBtn',
      showBack: true,
      onBack: onBack,
      withSubHeader: true,
      renderSubHeaderTitle: this.renderSubHeaderTitle,
    };
  };

  getButtonsSectionProps = () => {
    const { isPrimaryButtonDisabled } = this.state;
    const { onPressPrimary, onPressSecondary, onBack, theme } = this.props;

    return {
      isPrimaryButtonDisabled: isPrimaryButtonDisabled,
      theme: theme,
      primaryButtonTitle: 'billing_setup_installment_plan_primary_button_title',
      secondaryButtonTitle: 'billing_setup_installment_plan_secondary_button_title',
      onPressPrimary: () => onPressPrimary(this.selectedOptionData),
      onPressSecondary: onPressSecondary || onBack,
    };
  };
  renderSubHeaderTitle = () => {
    const { amount } = this.props;
    return <SubHeaderTitle title="billing_setup_installment_plan_screen_header" amount={amount} />;
  };
  renderChooseDurationSection = () => {
    const { theme, instalmentPlans } = this.props;
    return (
      <ChooseDurationSection
        onSelectOption={this.onSelectOption}
        theme={theme}
        instalmentPlans={instalmentPlans}
      />
    );
  };
  renderPaymentOptionsSection = () => {
    const { theme, dayOfMonthlyBill } = this.props;
    return (
      <PaymentOptionsSection
        title="billing_setup_installment_plan_payment_title"
        theme={theme}
        dayOfMonthlyBill={dayOfMonthlyBill}
      />
    );
  };
  render() {
    const { theme } = this.props;
    return (
      <VFScreen {...this.getVFScreenProps()}>
        <ScrollView style={style.contentStyle}>
          <Section
            theme={theme}
            title="billing_setup_installment_plan_duration_title"
            component={this.renderChooseDurationSection()}
          />
          <Section
            theme={theme}
            title="billing_setup_installment_plan_payment_header"
            component={this.renderPaymentOptionsSection()}
          />
          <ButtonsSection {...this.getButtonsSectionProps()} />
        </ScrollView>
      </VFScreen>
    );
  }
}

CreateInstalmentMainScreen.propTypes = {
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }).isRequired,
  onPressPrimary: PropTypes.func.isRequired,
  onPressSecondary: PropTypes.func,
  instalmentPlans: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subTitle: PropTypes.string,
    }),
  ).isRequired,
  amount: PropTypes.string.isRequired,
  dayOfMonthlyBill: PropTypes.string.isRequired,
};

export default CreateInstalmentMainScreen;
